import { useState, useCallback } from 'react';
import { get, post } from '../utils/networkUtils';

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async ({ limit = 10, offset = 0, search = '' }) => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams({
        limit: limit.toString(),
        offset: offset.toString(),
      });
      
      if (search) {
        params.append('search', search);
      }

      const response = await get(`/admin/users?${params.toString()}`);
      
      setUsers(response.users || []);
      setTotalUsers(response.totalUsers || 0);
      
      return response;
    } catch (err) {
      console.error('Error fetching users:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch users';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const addTickets = useCallback(async (userId, amount) => {
    try {
      const response = await post('/admin/tickets/add', {
        userId,
        amount,
      });
      
      return response;
    } catch (err) {
      console.error('Error adding tickets:', err);
      throw err;
    }
  }, []);

  const fixUserLeagues = useCallback(async () => {
    try {
      const response = await post('/admin/fix-user-leagues');
      return response;
    } catch (err) {
      console.error('Error fixing user leagues:', err);
      throw err;
    }
  }, []);

  return {
    users,
    totalUsers,
    loading,
    error,
    fetchUsers,
    addTickets,
    fixUserLeagues,
  };
};
